import { ajax } from "discourse/lib/ajax";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class ModMarketRoute extends DiscourseRoute {
  queryParams = {
    tab: { refreshModel: true },
    game: { refreshModel: true },
    character: { refreshModel: true },
    type: { refreshModel: true },
    sort: { refreshModel: true },
    q: { refreshModel: true },
    page: { refreshModel: true },
  };

  model(params) {
    return ajax("/mod-market-api/v1/mods.json", { data: params });
  }

  titleToken() {
    return i18n("discourse_mod_market.title");
  }
}
